import endpoint from '../../features/endPoints/ecommEndpoints';
import BaseClient from '../base/baseClient';

const featureControlClient = (cnumlist=[], zipcodes=[], source="", branches=[], featureFlags = []) => {
  const { post: postClient } = BaseClient();
  const requestBody = mapRequest(cnumlist, zipcodes, source, branches, featureFlags);
  return postClient(process.env.REACT_APP_ECOMM_URL+endpoint.featureControlNew(), requestBody);
};


//map body to request body as per API
const mapRequest = (cnumlist, zipcodes, source, branches, featureFlags) => {
    const featureControls = featureFlags.length > 0 ? featureFlags : ["F-CMARH", "F-CMARC", "F-CMARP", "F-CMAIR", "F-CMACH", "F-ESVCT", "F-CMACT", "F-MMACT", "F-MMACH", "LOYALTY", "LOYRDM", "LOYJOIN"];

    const featureFlagData = {
        "branches": branches,
        "customers": cnumlist,
        "featureControls": featureControls,
        "zipcodes": zipcodes,
        "source" : source
    }
    return featureFlagData;
};

export default featureControlClient;